<template>
  <el-dialog
    :title="isEdit ? '修改收款二维码' : '新增收款二维码'"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="formData" label-width="100px">
      <el-form-item label="名称" prop="name" required>
        <el-input v-model="formData.name" placeholder="必填，请填写二维码名称" />
      </el-form-item>
      <el-form-item label="提示语" prop="hint">
        <el-input v-model="formData.hint" placeholder="请填写扫码提示语" />
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <el-switch
          v-model="formData.state"
          active-value="Y"
          inactive-value="N"
          active-text="启用"
          inactive-text="停用"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="_submit">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveShopQrCode, updateShopQrCode } from '@/api/phone/shopQrCodeApi'

export default {
  name: 'AddShopQrCode',
  data() {
    return {
      dialogVisible: false,
      isEdit: false,
      formData: {
        qrId: '',
        name: '',
        hint: '',
        state: 'Y'
      }
    }
  },
  methods: {
    open(row) {
      if (row) {
        this.isEdit = true
        this.formData = {
          qrId: row.qrId,
          name: row.name,
          hint: row.hint,
          state: row.state
        }
      } else {
        this.isEdit = false
        this.formData = {
          qrId: '',
          name: '',
          hint: '',
          state: 'Y'
        }
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async _submit() {
      try {
        await this.$refs.form.validate()
        if (this.isEdit) {
          const res = await updateShopQrCode(this.formData)
          if (res.code === 0) {
            this.$message.success('修改成功')
            this.dialogVisible = false
            this.$emit('refresh')
          }
        } else {
          const res = await saveShopQrCode(this.formData)
          if (res.code === 0) {
            this.$message.success('新增成功')
            this.dialogVisible = false
            this.$emit('refresh')
          }
        }
      } catch (error) {
        console.error('保存失败:', error)
      }
    }
  }
}
</script>
